import { render, staticRenderFns } from "./dragmenu.vue?vue&type=template&id=75affc84&scoped=true"
import script from "./dragmenu.vue?vue&type=script&lang=js"
export * from "./dragmenu.vue?vue&type=script&lang=js"
import style0 from "./dragmenu.vue?vue&type=style&index=0&id=75affc84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75affc84",
  null
  
)

export default component.exports